import { getPagePath, NEXT_PAGE } from "./pageLinkSelectors";

export const getNextPagePath = state =>
  getPagePath({ state, direction: NEXT_PAGE });
